import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.set";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.regexp.search";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins.js";
import addCom from './components/addCom';
import transferCom from './components/transferCom';
import addAccoutAuth from "./accountManCom/addAccoutAuth";
import { merchant_list, area_list, handle_state as _handle_state, area_update, area_del, merchant_add, merchant_del, merchant_update, transfer_merchant_parent } from '@/api/jingxiaoshang';
import { Permission_config } from '@/api/auth';
export default {
  name: "areaClass",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this;

    return {
      areaData: [],
      cateList: [],
      nodeList: [],
      showSearchMore: false,
      form_filter: {
        cate_name: null,
        shop_name: null
      },
      //共用的右侧添加按钮
      topButtonList1: [{
        name: this.$t('add'),
        icon: 'ios-add',
        type: 'primary',
        method: this.add
      }],
      topButtonList: [{
        name: this.$t('query'),
        type: 'primary',
        icon: 'ios-search',
        method: this.search
      }, {
        name: this.$t('reset'),
        type: 'error',
        icon: 'ios-refresh',
        method: this.reset
      }],
      statusList: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '启用'
      }, {
        value: 2,
        label: '禁用'
      }],
      headBtnList1: [{
        method: this.add,
        type: 'primary',
        icon: 'ios-add',
        name: '新增'
      }, {
        name: '刷新',
        icon: 'ios-refresh',
        type: 'primary',
        method: this.init
      }],
      numObj: {
        1: '星期一',
        2: '星期二',
        3: '星期三',
        4: '星期四',
        5: '星期五',
        6: '星期六',
        7: '星期日'
      },
      searchReq: {
        mods: []
      },
      tableData: [],
      columnsData: [// {
      //   title: this.$t("serialnumber"),
      //   key: 'id',
      //   align: 'center',
      //   width:80,
      // },
      {
        title: this.$t('agentmenu.agentname'),
        key: 'shop_name',
        align: 'left',
        tree: true
      }, {
        title: this.$t('operation'),
        key: 'explain',
        align: 'center',
        width: 350,
        render: function render(h, _ref) {
          var row = _ref.row;
          var arr = [h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: '3px',
              color: '#2d8cf0'
            },
            props: {
              size: "small",
              type: 'text'
            },
            on: {
              "click": function click() {
                _this2.addChlid(row);
              }
            }
          }, _this2.$t('agentmenu.addsubagent'))]; //判断启用禁用

          var button_name = _this2.$t('agentmenu.forbidden');

          if (row.state == 2) {
            button_name = _this2.$t('agentmenu.enable');
          }

          arr.push(h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: '3px',
              color: '#2d8cf0'
            },
            props: {
              size: "small",
              type: 'text'
            },
            on: {
              "click": function click() {
                _this2.handle_state(row);
              }
            }
          }, button_name)); // arr.push(h("Button",{
          //     style:{
          //       marginRight:"3px",
          //       marginBottom:'3px', 
          //       color:'#2d8cf0',
          //     },
          //     props:{
          //       size:"small",
          //       type:'text',
          //     },
          //     on:{
          //       "click":()=>{ 
          //         this.transfer(row);
          //       }
          //     }
          // }, this.$t('agentmenu.transfer')));

          arr.push(h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: '3px',
              color: '#2d8cf0'
            },
            props: {
              size: "small",
              type: 'text'
            },
            on: {
              "click": function click() {
                _this2.roleEdit(row);
              }
            }
          }, _this2.$t('agentmenu.authority')));
          arr.push(h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: '3px',
              color: '#2d8cf0'
            },
            props: {
              size: "small",
              type: 'text'
            },
            on: {
              "click": function click() {
                _this2.edit(row);
              }
            }
          }, _this2.$t('edit')));
          arr.push(h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: '3px',
              color: '#2d8cf0'
            },
            props: {
              size: "small",
              type: 'text'
            },
            on: {
              "click": function click() {
                _this2.del(row);
              }
            }
          }, _this2.$t('delete')));
          return h("div", arr);
        }
      }],
      tableLoading: false,
      tabletotallen: 0,
      border: true,
      stripe: true,
      moduleShow: false,
      addBase: {
        name: "",
        code: "",
        state: "",
        explain: ""
      },
      reqBase: {
        page: 1,
        all: 1
      },
      states: [{
        value: 0,
        label: "禁用"
      }, {
        value: 1,
        label: "启用"
      }],
      modalTitle: true,
      ruleValidate: {
        name: [{
          required: true,
          message: '请输入模块名',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入模块代码',
          trigger: 'change'
        }],
        explain: [{
          required: true,
          message: '请输入说明',
          trigger: 'blur'
        }],
        state: [{
          required: true,
          message: '请选择状态',
          trigger: 'change'
        }]
      }
    };
  },
  components: {},
  computed: {
    modelList: function modelList() {
      return this.$store.state.authCenter.ModuleData;
    }
  },
  methods: {
    // roleEdit() {
    //   alert("功能开发中"); 
    // },
    roleEdit: function roleEdit(row) {
      var _this3 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 600,
        render: function render(h) {
          return h("div", [h("div", {
            slot: "title",
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", _this3.$t('权限配置')), h("Icon", {
            style: {
              cursor: "pointer",
              fontSize: "30px",
              color: "#000"
            },
            props: {
              type: "ios-close"
            },
            on: {
              click: function click() {
                _this3.$Modal.remove();
              }
            }
          })]), h(addAccoutAuth, {
            ref: "addAccoutAuth",
            props: {
              edit: true,
              _vm: vm,
              setData: row,
              merchant_code: row.merchant_code
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addAccoutAuth;
          obj.formCheck().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              var interConfit = obj.interConfit;
              var menu_config = formModel.menu_config; //获取选中项目

              var seletctItem = obj.$refs.interConfitTree.getCheckedAndIndeterminateNodes();
              var itemMenuConfig = [];

              var getSelctItem = function getSelctItem(data) {
                for (var i in data) {
                  var list = data[i];

                  if (list.checked) {
                    //判断 数组中是否存在id
                    if (itemMenuConfig.indexOf(list.code) === -1) {
                      itemMenuConfig.push(list.code);
                    } //当没有会选时，将parent_id 强行加入


                    if (itemMenuConfig.indexOf(list.parent_code) === -1 && list.parent_code !== "0") {
                      itemMenuConfig.push(list.parent_code);
                    }
                  }

                  if (list.children && list.children.length > 0) {
                    getSelctItem(list.children);
                  }
                }
              };

              getSelctItem(seletctItem);
              var result = [];

              var getApiConfig = function getApiConfig(data) {
                for (var i in data) {
                  var list = data[i];

                  if (list.category && list.category === 1) {
                    //先取编辑时所先的值,如果没有,再从原信息里面取
                    if (itemMenuConfig.indexOf(list.code) > -1 && obj.currSelectList.hasOwnProperty(list.code)) {
                      result.push.apply(result, _toConsumableArray(obj.currSelectList[list.code].filter(function (number) {
                        return number !== null;
                      })));
                    } else {
                      if (list.api_codes && itemMenuConfig.indexOf(list.code) > -1) {
                        result.push.apply(result, _toConsumableArray(list.api_codes.filter(function (number) {
                          return number !== null;
                        })));
                      }
                    }
                  }

                  if (list.children && list.children.length > 0) {
                    getApiConfig(list.children);
                  }
                }
              };

              getApiConfig(interConfit); //this.areaData.splice(0)

              Permission_config({
                admin_id: row.admin_id,
                menu_config: itemMenuConfig,
                //菜单id组成的数组
                api_config: Array.from(new Set(result)) //接口id组成的数组

              }).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              }); //api 去重操作 
              //保存经销商权限
              // vm.$store
              //   .dispatch("operation/handlePermission_config", {
              //     admin_id: row.admin_id,
              //     menu_config: itemMenuConfig, //菜单id组成的数组
              //     api_config: Array.from(new Set(result)) //接口id组成的数组
              //   })
              //   .then((res) => {
              //     if (res.result === 0) {
              //       vm.$Message.success(res.errorMsg)
              //       vm.$Modal.remove()
              //       vm.init()
              //     } else {
              //       vm.$Message.error(res.errorMsg)
              //       _this.buttonLoading = false
              //     }
              //   })
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    getAreaData: function getAreaData() {
      var _this4 = this;

      this.areaData.splice(0);
      area_list({
        page: 1,
        page_size: 1000,
        parent_code: 1,
        all: 2,
        type: 1
      }).then(function (res) {
        if (res.result === 0) {
          //console.log(data)
          var data = res.body.list;

          _this4.checkTree(data); // console.log('a',data)


          _this4.areaData = data;
        }
      });
    },
    checkTree: function checkTree(arr) {
      for (var i in arr) {
        if (arr[i].area_name) {
          arr[i].value = arr[i].area_code;
          arr[i].label = arr[i].area_name;
          arr[i].title = arr[i].area_name;
        } else if (arr[i].shop_name) {
          arr[i].title = arr[i].shop_name;
        }

        if (arr[i].children_shop && arr[i].children_shop.length > 0) {
          var _arr$i$children;

          (_arr$i$children = arr[i].children).push.apply(_arr$i$children, _toConsumableArray(arr[i].children_shop));
        }

        if (arr[i].children && arr[i].children.length > 0) {
          this.checkTree(arr[i].children);
        }
      }
    },
    handleLoadData: function handleLoadData(item, callback) {
      // console.log("11111")
      var vm = this;

      var callbak = function callbak(res) {
        if (res.result === 0) {
          var data = res.body.list || [];

          for (var i in data) {
            var list = data[i];

            if (list.has_child === 1) {
              list._loading = false;
              list.children = [];
              list.parent_code = item.merchant_code;
              list.parent_name = item.shop_name;
            }
          }

          callback(data);
        } else {}
      };

      merchant_list({
        page_size: -1,
        page: 1,
        parent_code: item.merchant_code,
        all: 1
      }).then(function (res) {
        callbak(res);
      }).catch(function (err) {// this.tableLoading=false;
      });
    },
    createTree: function createTree(data) {
      for (var i in data) {
        var list = data[i];
        list['value'] = list.node_code;
        list['label'] = list.node_name;

        if (list.children && list.children.length > 0) {
          this.createTree(list.children);
        }
      }
    },
    createTree1: function createTree1(data) {
      for (var i in data) {
        var list = data[i];
        list['value'] = list.cate_code;
        list['label'] = list.cate_name;

        if (list.children && list.children.length > 0) {
          this.createTree1(list.children);
        }
      }
    },
    getTreeCateNodeData: function getTreeCateNodeData(callback) {
      var _this5 = this;

      this.spinShow = true;
      this.cateList.splice(0);
      patrolcateGetAllCate({
        project_code: this.$store.state.user.projectCode
      }).then(function (res) {
        _this5.spinShow = false;

        if (res.result === 0) {
          var _this5$cateList;

          var data = res.body;

          _this5.createTree1(data);

          (_this5$cateList = _this5.cateList).push.apply(_this5$cateList, _toConsumableArray(data));

          if (callback) {
            callback(_this5.cateList);
          }
        } else {}
      });
    },
    getTreeNodeData: function getTreeNodeData(callback) {
      var _this6 = this;

      this.spinShow = true;
      this.nodeList.splice(0);
      get_all_cate({
        project_code: this.$store.state.user.projectCode
      }).then(function (res) {
        _this6.spinShow = false;

        if (res.result === 0) {
          var _this6$nodeList;

          var data = res.body;

          _this6.createTree(data);

          (_this6$nodeList = _this6.nodeList).push.apply(_this6$nodeList, _toConsumableArray(data));

          if (callback) {
            callback(_this6.nodeList);
          }
        } else {}
      });
    },

    /**
     * 修改状态
     */
    changeStatus: function changeStatus(row, title) {
      var _this7 = this;

      var _this = this;

      var config = {
        loading: true,
        title: title,
        width: 400,
        content: "<p>\u60A8\u786E\u8BA4\u8981".concat(title, "<span style=\"color: #f60;\">").concat(row.plan_name, "</span>\uFF1F</p>"),
        onOk: function onOk() {
          var params = {
            plan_code: row.plan_code
          },
              callbak = function callbak(req) {
            if (req.result === 0) {
              _this7.$Message.success(req.errorMsg);

              _this7.$Modal.remove();

              _this7.init();
            } else {
              _this7.buttonLoading = false;

              _this7.$Message.error(req.errorMsg);
            }
          }; //删除接口


          handle_catch_fear_status(params).then(function (res) {
            callbak(res);
          });
        }
      };
      this.$Modal.confirm(config);
    },
    showMore: function showMore() {
      if (!this.showSearchMore) {
        this.showSearchMore = true;
      } else {
        this.showSearchMore = false;
      }
    },
    init: function init() {
      this.getAreaData();
      this.getPageSizeToStorage();
      this.getData();
    },

    /**
     * 初始化数据
     */
    getData: function getData() {
      var _this8 = this;

      this.tableData.splice(0);
      this.tableLoading = true;
      var vm = this;

      var callbak = function callbak(res) {
        _this8.tableLoading = false;

        if (res.result === 0) {
          var data = res.body.list || [];
          console.log(data);

          for (var i in data) {
            var list = data[i];

            if (list.has_child == 1) {
              // console.log(Vue.version) 
              list._loading = false;
              list.parent_code = '0';
              list.parent_name = '无';
              list.children = [];
            }

            console.log(list);
            vm.tableData.push(list);
          }

          console.log('251988', res.body.total);
          vm.tabletotallen = res.body.total;
        } else {
          vm.tableData = [];

          _this8.$Message.error(res.errorMsg);
        }
      };

      merchant_list(this.reqBase).then(function (res) {
        callbak(res);
      }).catch(function (err) {
        _this8.tableLoading = false;
      });
    },

    /**
     * 重置搜索框
     */
    resetSearch: function resetSearch() {
      this.searchReq = {
        mods: []
      };
    },
    okSearch: function okSearch() {
      Object.assign(this.reqBase, this.searchReq); //重置当前页为1

      this.reqBase.page = 1;
      this.$refs.contentBaseRef.initcurrentPage();
      this.init();
    },

    /**
     * 翻页
     */
    pageonChange: function pageonChange(index) {
      this.reqBase.page = index;
      this.getData();
    },

    /**
     * 筛选
     */
    showSearchParel: function showSearchParel() {
      this.$refs.search.expandPanel();
    },
    addChlid: function addChlid(row) {
      var _this9 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, _this9.$t('新增') + row.shop_name + _this9.$t('下级代理商')), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(addCom, {
            ref: 'addCom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              parent_code: row.merchant_code,
              parent_name: row.shop_name
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addCom;
          obj.checkForm().then(function (res) {
            if (res) {
              // console.log(...obj.formModel)
              // return;
              //debugger
              merchant_add(_objectSpread({}, obj.formModel)).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg = res.errorMsg;
                  vm.$Message.success(_msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    add: function add() {
      var _this10 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, _this10.$t('agentmenu.addagent')), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(addCom, {
            ref: 'addCom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              parent_code: '0',
              parent_name: '无'
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addCom;
          obj.checkForm().then(function (res) {
            if (res) {
              merchant_add(_objectSpread({}, obj.formModel)).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg2 = res.errorMsg;
                  vm.$Message.success(_msg2);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    edit: function edit(row) {
      var _this11 = this;

      console.log('a', row);
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, _this11.$t('编辑代理商')), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(addCom, {
            ref: 'addCom',
            props: {
              edit: true,
              $store: vm.$store,
              _vm: vm,
              setData: row
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addCom;
          obj.checkForm().then(function (res) {
            if (res) {
              var _obj$formModel = obj.formModel,
                  area_name = _obj$formModel.area_name,
                  desc = _obj$formModel.desc,
                  area_code = _obj$formModel.area_code;
              merchant_update(_objectSpread({}, obj.formModel)).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg3 = res.errorMsg;
                  vm.$Message.success(_msg3);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    transfer: function transfer(row) {
      //console.log('a',row)
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, '转移代理商'), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(transferCom, {
            ref: 'addCom',
            props: {
              edit: true,
              $store: vm.$store,
              _vm: vm,
              setData: row
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addCom;
          obj.checkForm().then(function (res) {
            if (res) {
              // let { area_name, desc, area_code } = obj.formModel
              transfer_merchant_parent(_objectSpread({}, obj.formModel)).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg4 = res.errorMsg;
                  vm.$Message.success(_msg4);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    search: function search() {
      this.onSearch(this.form_filter);
    },
    reset: function reset() {
      this.form_filter = {
        area_code: [],
        shop_name: null
      };
      this.search();
    },

    /**
    * 删除
    */
    handle_state: function handle_state(row) {
      var button_name = "禁用";

      if (row.state == 2) {
        button_name = "启用";
      }

      var vm = this;
      this.$Modal.confirm({
        title: this.$t('操作状态'),
        content: this.$t('您确定要') + this.$t(button_name) + row.shop_name + '？',
        loading: true,
        onOk: function onOk() {
          var _this = this;

          _handle_state({
            merchant_code: row.merchant_code
          }).then(function (res) {
            var msg = res.errorMsg;

            if (res.result === 0) {
              var _msg5 = res.errorMsg;
              vm.$Message.success(_msg5);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(msg);
              _this.buttonLoading = false;
            }
          });
        }
      });
    },

    /**
     * 删除
     */
    del: function del(row) {
      var vm = this;
      this.$Modal.confirm({
        title: this.$t('删除'),
        content: this.$t('您确定要') + this.$t('删除') + row.shop_name + '？',
        loading: true,
        onOk: function onOk() {
          var _this = this;

          merchant_del({
            merchant_code: row.merchant_code
          }).then(function (res) {
            var msg = res.errorMsg;

            if (res.result === 0) {
              var _msg6 = res.errorMsg;
              vm.$Message.success(_msg6);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(msg);
              _this.buttonLoading = false;
            }
          });
        }
      });
    }
  },
  mounted: function mounted() {
    this.$set(this.reqBase, 'project_code', this.$store.state.user.projectCode);
    this.init();

    window.onresize = function () {// this.changeTableHeight()
    };

    this.$nextTick(function () {// this.changeTableHeight()
    });
  },
  created: function created() {},
  destroyed: function destroyed() {
    window.onresize = null;
  }
};